import { AnyAction } from 'redux';
import { taasInfoReducer } from '@ps20-frontend/preis-lib';
import { App, TaasInfo } from '@ps20-frontend/frontend-models';
import { IAppState } from '../appState';

export const gegeTaasInfoReducer = function (
  sectionState: TaasInfo = null,
  action: AnyAction,
  state: IAppState,
): TaasInfo {
  return taasInfoReducer(sectionState, action, App.GEGE, state?.angebotsId);
};
